export function parseSchedulingError(error) {
  const data = error?.response?.data;
  const status = error?.response?.status;
  const nested = data?.error;
  const message =
    (nested && typeof nested === "object" && nested.message) ||
    (typeof nested === "string" ? nested : null) ||
    data?.message ||
    error?.message;
  const code = nested && typeof nested === "object" ? nested.code : undefined;
  return {
    status,
    code,
    message,
    requestId: data?.requestId,
    raw: data,
  };
}

export function schedulingErrorMessage(error, fallback = "Request failed.") {
  const parsed = parseSchedulingError(error);
  const message = parsed.message || "";

  if (parsed.status === 409) {
    if (/service category has active or future bookings/i.test(message)) {
      return "This category is used by an active hold or appointment.";
    }
    if (/version does not match/i.test(message)) {
      return "This record changed. Refresh and try again.";
    }
    if (/scheduling conflict \(schedules_no_practitioner_overlap\)/i.test(message)) {
      return "This practitioner already has an active schedule for those dates. End or cancel it before adding another.";
    }
    if (/scheduling conflict \(availability_rule_no_active_range_overlap\)/i.test(message)) {
      return "This schedule already has a work schedule for those dates. Edit it, or give it an end date, before adding another.";
    }
    return message || "This change conflicts with an existing booking or hold.";
  }
  if (parsed.status === 404) {
    return message || "Not found.";
  }
  if (parsed.status === 400) {
    return message || "Invalid request.";
  }
  return message || fallback;
}

export function isConflictError(error) {
  return parseSchedulingError(error).status === 409;
}
